import styled from '@emotion/styled';
import React from 'react';
import Responsive from '../../../../../ui/utils/Responsive';
import illustration from '../../../../../../assets/flights-not-found.svg?reference';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';

export const BookingDetailsNotFound = () => {
	const { t } = useTranslation();

	return (
		<div>
			<StyledImage src={illustration} alt="" />
			<StyledDescription>
				{t('parking_booking_details_not_found')}
			</StyledDescription>
		</div>
	);
};

const StyledImage = styled.img`
	display: block;
	width: 300px;
	max-width: 80vw;
	margin: 80px auto 40px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin: 40px auto 24px;
	}
`;

const StyledDescription = styled.p`
	display: block;
	margin: 0 auto 40px;
	text-align: center;
`;
